export const evidenceTableColumnsClass =
  "grid-cols-[40px_72px_minmax(8rem,1fr)_120px_124px_120px_96px] xl:grid-cols-[44px_84px_minmax(10rem,1fr)_144px_156px_148px_112px]";

export const EVIDENCE_DEFAULT_SORT_KEY = "code" as const;
export const EVIDENCE_DEFAULT_SORT_DIRECTION = "asc" as const;
